import React from "react";
import { User } from "lucide-react";
import { UserProfile } from "./user-profile/UserProfile"; // Fixed import path

export const Header = () => {
  return (
    <header className="header">
      <div className="flex items-center gap-0.5 header-title">
        {/* Updated logo element */}
        <img
          src="/favicon.ico"
          alt="Logo"
          className="logo"
        />
        <h2>
          SimplePLAB<sup>2</sup>
        </h2>
      </div>
      <UserProfile />
    </header>
  );
};
